export class ReferenciaDteEmitido {
   //class directly related to DteEmitido, used while assigning reference to individual dte
   fechaDteReferenciado: Date;
   razonReferencia: string;
   codigoTipoDteReferencia: string;
   folioReferencia: string;
   codigoRazonReferencia: number;
   isValid: boolean;
}
